/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Media_More_CountInputs */

const vi_media_more_count = /** @type {(inputs: Media_More_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`+${i?.count}`)
};

/**

* @param {Media_More_CountInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const media_more_count = /** @type {((inputs: Media_More_CountInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_More_CountInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_media_more_count(inputs)
});